/**
 * Breakpoint alinhado ao `md` do Tailwind (768px).
 * Viewport menor → UI mobile (/m/*).
 */
export const MOBILE_VIEWPORT_MAX = 767;

/**
 * Mapeia rotas web com equivalente mobile.
 * Retorna null quando não há versão mobile (mantém a rota web).
 */
export function resolveMobilePath(pathname: string): string | null {
  if (pathname === "/login") return "/m/login";
  if (pathname === "/" || pathname === "") return "/m/chat";

  if (pathname === "/chat" || pathname === "/chat/") return "/m/chat";
  if (pathname.startsWith("/chat/")) {
    const contactId = pathname.slice("/chat/".length).split("/")[0];
    if (contactId) return `/m/chat/${contactId}`;
  }

  if (pathname === "/contacts" || pathname === "/contacts/") return "/m/contatos";

  if (pathname === "/crm" || pathname === "/crm/") return "/m/crm";

  return null;
}

/**
 * Mapeia rotas /m/* de volta para o web (desktop / viewport largo).
 */
export function resolveDesktopPath(pathname: string): string | null {
  if (pathname === "/m/login") return "/login";
  if (pathname === "/m" || pathname === "/m/" || pathname === "/m/chat" || pathname === "/m/chat/") {
    return "/chat";
  }

  if (pathname.startsWith("/m/chat/")) {
    const contactId = pathname.slice("/m/chat/".length).split("/")[0];
    if (contactId) return `/chat/${contactId}`;
  }

  if (pathname === "/m/contatos" || pathname === "/m/contatos/") return "/contacts";

  if (pathname === "/m/crm" || pathname === "/m/crm/") return "/crm";

  return null;
}
